import { FC } from 'react';
import styled from '@emotion/styled';
import Slider from '@mui/material/Slider';
import { SliderOwnProps } from '@mui/material/Slider/Slider';

const StyledSlider = styled(Slider)(
  () => `
  height: 6px;
  padding: 0;
  
  @media (pointer: coarse) {
    padding: 0
  }

  .MuiSlider-track {
    background-color: var(--brand-color);
  }
  .MuiSlider-rail {
    background-color: var(--light-gray);
    opacity: unset;
  }
  .MuiSlider-thumb {
    width: var(--size-standard);
    height: var(--size-standard);
    background-color: var(--brand-color);
  }
`
);

interface Props extends SliderOwnProps {
  handler: (value: number) => void;
}

export const SliderMui: FC<Props> = ({ handler, ...props }) => {
  const handleValue = (event: Event, value: number | number[]) => {
    handler(value as number);
  };
  return <StyledSlider {...props} onChange={handleValue} />;
};
